import { render, staticRenderFns } from "./LeftForm.vue?vue&type=template&id=54a7163c&scoped=true&"
import script from "./LeftForm.vue?vue&type=script&lang=js&"
export * from "./LeftForm.vue?vue&type=script&lang=js&"
import style0 from "./LeftForm.vue?vue&type=style&index=0&id=54a7163c&prod&lang=scss&"
import style1 from "./LeftForm.vue?vue&type=style&index=1&id=54a7163c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7163c",
  null
  
)

export default component.exports